<template>

	<LibraryShowcase>
		<li>
			<figure>
				<img src="~img/carousel/lightning.jpg">
			</figure>
			<figure>
				<img src="~img/carousel/mice-and-men.jpg">
			</figure>
		</li>
		<li>
			<figure>
				<img src="~img/carousel/girl-camera.jpg">
			</figure>
			<figure>
				<img src="~img/carousel/laughing-girl1.jpg">
			</figure>
		</li>
		<li>
			<figure>
				<img src="~img/carousel/lord-of-flies.jpg">
			</figure>
			<figure>
				<img src="~img/carousel/girl-on-stage.jpg">
			</figure>
		</li>
		<li>
			<figure>
				<img src="~img/carousel/behind-scenes.jpg">
			</figure>
			<figure>
				<img src="~img/carousel/bus.jpg">
			</figure>
		</li>
		<li>
			<figure>
				<img src="~img/carousel/shakespear.jpg">
			</figure>
			<figure>
				<img src="~img/carousel/circuit.jpg">
			</figure>
		</li>
	</LibraryShowcase>

</template>

<script>

	import LibraryShowcase from '@/components/LibraryShowcase'

	export default {
		components: { LibraryShowcase }
	}

</script>



// WEBPACK FOOTER //
// src/components/CompanyTour/components/LibraryShowcase.vue